import http from '../plugins/axios'
import { updateOrder } from './orders'

export const calculation = async (orderId) => {
  const payload = {
    type: 'manage-order',
    order_id: orderId,
  }
  try {
    const response = await http.post(`/api/v2/calculation`, payload)
    const resCalculate = response.data.data

    const {
      logistic_per_unit,
      total_goods_value,
      total_custom_goods_value,
      total_weight,
      total_cbm,
      total_custom_charge,
      total_logistic_charges,
      total_logistic_all_in,
      grand_total,
      total_duty,
      total_wht,
      total_vat,
      items
    } = resCalculate

    const remapItems = items.map(val => {
      return {
        detail_id: val.id,
        landed_cost: val.landed_cost_all_in_per_pieces,
        logistic_cost: val.total_logistic_all_in_per_pieces,
        landed_cost_exclude_vat: val.landed_cost_exclude_vat_per_pieces
      }
    })

    const payloadOrder = {
      logistic_per_unit,
      total_goods_value,
      total_custom_goods_value,
      total_weight,
      total_cbm,
      total_custom_charge,
      total_logistic_charges,
      total_logistic_all_in,
      grand_total,
      total_duty,
      total_wht,
      total_vat,
      total_custom_charges: total_custom_charge,
      items: remapItems,
    }

    const updateOrder = handleUpdateOrder(orderId, payloadOrder)
    return updateOrder
  } catch(error) {
    throw error
  }
}

const handleUpdateOrder = async(orderId, payload) => {
  try {
    const response = await updateOrder(orderId, payload)
    return response
  } catch (error) {
    console.log(error)
  }
}